const Header = () => {
    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:pt-8 lg:pb-8 text-zinc-800 dark:text-zinc-200 text-sm">
            <div className="flex flex-cols items-end">
                <div className="lg:flex-none lg:w-9/12">
                    <div className="flex flex-row items-center space-x-2">
                        <span className="hidden bg-purple-500 lg:inline-block h-2 w-2 rounded-full shadow-[0_0_8px_#a855f7]"></span>
                        <span className="hidden mt-4 lg:inline-block lg:mt-0 text-purple-600 dark:text-purple-400 uppercase font-sans text-xs tracking-widest font-semibold">Pricing</span>
                    </div>
                    <h1 className="py-4 text-3xl lg:text-5xl font-bold text-zinc-900 dark:text-white">
                        <span className="text-purple-600 dark:text-purple-400">Solutions & Tiers</span> at Jibu Labs
                    </h1>
                    <p className="text-sm text-zinc-500 dark:text-zinc-400 leading-relaxed font-light">Flexible and scalable plans engineered to fit your business size and AI ambitions.</p>
                </div>
            </div>
        </div>
    )
}

export default Header
